import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormHelperService } from '../core/services/form-helper.service';
import { FilterItemsService } from "../reports";
import { CreativesService } from './creative.services';
import { DropdownValue } from '../shared/dropdown.model';
import { consts } from "../shared/consts";
import { DropdownComponent } from '..';
import { DatePipe } from '@angular/common'
import { ClaimsService } from '../core/services';
import { CountryTreeSelectionModalComponent } from '../shared/country-tree-selection-modal.component';
import { MediationService } from '../mediation';
import { forEach } from 'core-js/fn/array';
import { TreeSelectionModel } from '../shared/tree-selection.model';

@Component({
    moduleId: module.id,
    selector: 'creative-modal',
    templateUrl: 'creative-modal.component.html'
})

export class CreativeModalComponent implements OnInit {
    isSambaAdmin: boolean = false;

    position: number;
    positionValues: Array<DropdownValue> = [];

    publisherId: number = 0;
    publisherValues: Array<DropdownValue> = [];

    providerId?: number = null;
    providerValues: Array<DropdownValue> = [];
    shouldShowProviders: boolean = false;

    countrySelection: string = "";
    @ViewChild("countriesTreeSelectionModal") countriesTreeSelectionModalComponent: CountryTreeSelectionModalComponent
    shouldShowCountries: boolean = false;
    inputCountries: Array<TreeSelectionModel> = new Array<TreeSelectionModel>();

    creativeForm: FormGroup;
    isSaving: boolean = false;
    isLoading: boolean = false;
    private readonly modalId = "#creativeLogoModal";

    file: File;
    showUploadError: boolean = false;
    showUploadFileSizeExceededError: boolean = false;

    startDate: Date = new Date();
    endDate: Date = new Date();
    minDate: Date = new Date();
    dateError: string;

    showTargetAudienceError: boolean = false;

    @ViewChild('positionDropdown') positionDropdown: DropdownComponent;
    @ViewChild('publisherDropdown') publisherDropdown: DropdownComponent;
    @ViewChild('providerDropdown') providerDropdown: DropdownComponent;

    @Output() creativeCreated: EventEmitter<any> = new EventEmitter<Event>();

    private inXhrGetProviders: any;
    private inXhrGetCountries: any;

    constructor(private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        private creativesService: CreativesService,
        private filterItemsService: FilterItemsService,
        private claimsService: ClaimsService,
        private el: ElementRef,
        public datePipe: DatePipe) {
    }

    ngOnInit() {
        this.isSambaAdmin = this.claimsService.getUserTypeId() === 1;

        this.creativeForm = this.formBuilder.group({
            nameField: ['', [Validators.required]],
            videoField: ['', [Validators.required]],
            startDateField: ['', [Validators.required]],
            endDateField: ['', [Validators.required]],
            prepaidConsumer: ['', []],
            postpaidConsumer: ['', []],
            postpaidCorporate: ['', []],
        });

        this.positionValues.push(new DropdownValue(1, '1'));
        this.positionValues.push(new DropdownValue(2, '2'));
        this.positionValues.push(new DropdownValue(3, '3'));
        this.positionValues.push(new DropdownValue(4, '4'));
        this.positionValues.push(new DropdownValue(5, '5'));

        this.filterItemsService.getPublishers().forEach(element => {
            this.publisherValues.push(new DropdownValue(element.value, element.label));
        });

        this.minDate.setDate(new Date().getDate() - 1);
    }

    onPositionValueChanged(item) {
        this.position = item.value;
    }

    onPublisherValueChanged(item) {
        this.isLoading = true;
        this.publisherId = item.value;
        this.providerId = null;
        this.shouldShowProviders = false;
        this.countrySelection = '';
        this.shouldShowCountries = false;

        if (this.isSambaAdmin) {
            if (this.inXhrGetProviders) {
                this.inXhrGetProviders.unsubscribe();
            }
            this.inXhrGetProviders = this.creativesService.getProvidersForPublisher(this.publisherId)
                .subscribe((res: any) => {
                    this.providerValues = [];
                    res.json().forEach(element => {
                        this.providerValues.push(new DropdownValue(element.id, element.name));
                    });
                    this.shouldShowProviders = true;
                    this.isLoading = false;
                }, error => { }, () => { });
        } else {
            this.getCountriesForSelection();
        }
    }

    onProviderValueChanged(item) {
        this.isLoading = true;
        this.providerId = item.value;

        this.getCountriesForSelection();
    }

    private getCountriesForSelection() {
        this.countrySelection = '';
        this.shouldShowCountries = false;

        if (this.inXhrGetCountries) {
            this.inXhrGetCountries.unsubscribe();
        }
        this.inXhrGetCountries = this.creativesService.getCountriesForPublisherAndProvider(this.publisherId, this.providerId)
            .subscribe((res: any) => {
                this.inputCountries = [];
                res.json().forEach(element => {
                    this.inputCountries.push(new TreeSelectionModel(element.id, element.countryCode, 'Countries', false));
                });
                this.shouldShowCountries = true;
                this.isLoading = false;
            }, error => { }, () => { });
    }

    onCountryValueChanged(selectedCountryIds) {
        if (this.countrySelection.length > 0) {
            this.countrySelection += "," + selectedCountryIds.join(", ");
        }
        else {
            this.countrySelection = selectedCountryIds.join(", ");
        }
    }

    onSaveChanges(event: any) {
        if (this.startDate > this.endDate) {
            this.dateError = consts.StartDateGreaterThanEndDateText;
            return;
        }
        this.dateError = '';
        this.showTargetAudienceError = false;
        if (this.file.size > 200 * 1024 * 1024) //200MB
            this.showUploadFileSizeExceededError = true;
        else this.showUploadFileSizeExceededError = false;

        if (!this.creativeForm.valid)
            return;

        if (!this.creativeForm.value.prepaidConsumer && !this.creativeForm.value.postpaidConsumer && !this.creativeForm.value.postpaidCorporate) {
            this.showTargetAudienceError = true;
            return;
        }

        this.isSaving = true;
        let targetAudiences = '';
        if (this.creativeForm.value.prepaidConsumer)
            targetAudiences = "0";

        if (this.creativeForm.value.postpaidConsumer) {
            if (targetAudiences)
                targetAudiences += ",1";
            else
                targetAudiences = "1"
        }

        if (this.creativeForm.value.postpaidCorporate) {
            if (targetAudiences)
                targetAudiences += ",2";
            else
                targetAudiences = "2"
        }

        var selectedPublisher = this.publisherValues.find(x => x.value == this.publisherId)
        this.creativesService.createCreative(this.creativeForm.value.nameField,
            this.datePipe.transform(new Date(Date.UTC(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())), 'MM/dd/yyyy'),
            this.datePipe.transform(new Date(Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate())), 'MM/dd/yyyy'),
            this.position, this.publisherId, selectedPublisher.label,
            this.countrySelection, targetAudiences, this.file, this.providerId)
            .subscribe(() => {
                this.creativeCreated.emit();
                $(this.modalId).modal('hide');
            }, (error: any) => { this.isSaving = false; }, () => { this.isSaving = false; });
    }

    showCreateCreative() {
        this.isSaving = false;
        this.creativeForm.reset();
        this.showUploadError = false;
        this.showUploadFileSizeExceededError = false;

        this.positionDropdown.setCurrentSelection(this.positionValues[0]);
        this.position = this.positionValues[0].value;

        if (this.publisherDropdown)
            this.publisherDropdown.resetSelection();
        this.publisherId = 0;

        this.shouldShowProviders = false;
        if (this.providerDropdown)
            this.providerDropdown.resetSelection();
        this.providerValues = [];
        this.providerId = null;

        this.shouldShowCountries = false;
        if (this.countriesTreeSelectionModalComponent)
            this.countriesTreeSelectionModalComponent.resetSelection();
        this.countrySelection = "";
        this.inputCountries = [];

        $(this.modalId).modal('show');
    }

    onUploadChanged(event): void {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.file = fileList[0];
            this.showUploadError = false;
        }
        else {
            this.file = null;
            this.showUploadError = true;
        }
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.creativeForm, controlName, validator);
    }

    onDateClicked(event) {
        let ng2datePicker = this.el.nativeElement.querySelectorAll("ng2-datetime-picker[draggable='true']");
        $(ng2datePicker).attr('draggable', 'false');
    }

    onClose(event) {
        if (this.inXhrGetProviders) {
            this.inXhrGetProviders.unsubscribe();
        }
        if (this.inXhrGetCountries) {
            this.inXhrGetCountries.unsubscribe();
        }
        this.publisherId = 0;
        this.providerId = null;
        this.shouldShowProviders = false;
        this.countrySelection = '';
        this.shouldShowCountries = false;
        this.isLoading = false;
    }

    ngOnDestroy() {
        if (this.inXhrGetProviders) {
            this.inXhrGetProviders.unsubscribe();
        }
        if (this.inXhrGetCountries) {
            this.inXhrGetCountries.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/creatives/creative-modal.component.ts